import axios from 'axios';
import { toast } from 'react-hot-toast';
import { API_BASE_URL } from './config';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Increased to 30 seconds for operations that generate emails
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('sadfsgs')

console.log('22universal@12345')
// Add token to request headers
axiosInstance.interceptors.request.use(
  (config) => {
    // List of endpoints that don't require authentication
    const publicEndpoints = [
      'request-otp',
      'verify-otp',
      'login',
      'register',
      'forgot-password',
      'reset-password',
      'verifyCustomerEmail'
    ];
    console.log('asda')

    // Check if the current request is to a public endpoint
    const isPublicEndpoint = publicEndpoints.some(endpoint =>
      config.url?.includes(endpoint)
    );

    // Only add auth token if NOT a public endpoint
    if (!isPublicEndpoint) {
      // Try new authData first, then fall back to authToken
      const authData = localStorage.getItem('authData');
      const authToken = localStorage.getItem('authToken');

      if (authData) {
        try {
          const parsed = JSON.parse(authData);
          const now = new Date();
          if (parsed.expiry > now.getTime()) {
            config.headers.Authorization = `Bearer ${parsed.token}`;
          } else {
            localStorage.removeItem('authData');
            localStorage.removeItem('authToken'); // Clean both
          }
        } catch {
          localStorage.removeItem('authData'); // Corrupt data
        }
      } else if (authToken) {
        // Fallback to old authToken format
        try {
          const parsed = JSON.parse(authToken);
          const now = new Date();
          if (parsed.expiry > now.getTime()) {
            config.headers.Authorization = `Bearer ${parsed.token}`;
          } else {
            localStorage.removeItem('authToken'); // Expired
          }
        } catch {
          localStorage.removeItem('authToken'); // Corrupt token
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Global Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log(response , 'Response@12345')

    // Only show toast for mutation operations (POST, PUT, PATCH, DELETE), not GET requests
    const isMutation = response?.config?.method &&
                       ['post', 'put', 'patch', 'delete'].includes(response.config.method.toLowerCase());

    // Don't show toast for will quote detail fetch (silent fetch for Quote Summary)
    const shouldSkipToast = response?.config?.url?.includes('get-will-quote-detail') ||
                           response?.config?.url?.includes('get-lss-will-quote-detail') ||
                           response?.config?.url?.includes('userList') ||
                           response?.config?.url?.includes('List') ||
                           response?.config?.url?.includes('leadsList') ||
                           response?.config?.url?.includes('leads-list') ||
                           response?.config?.url?.includes('get-single-lead') ||
                           response?.config?.url?.includes('getEditData') ||
                           response?.config?.url?.includes('getEmailLogs') ||
                           response?.config?.url?.includes('getImmediateAutomations') ||
                           response?.config?.url?.includes('sendEmailFromTemplate') ||
                           response?.config?.url?.includes('verifyCustomerEmail') ||
                           response?.config?.url?.includes('lead-edit');

    if (response?.data?.message && isMutation && !shouldSkipToast) {
        //console.log(response , 'Response@12345')
      toast.success(response.data.message);
    }

    return response;
  },
  (error) => {
    console.log(error , 'ERROR@1234567')
    if (!error.response) {
      // Handle network errors, timeouts, etc.
      const errorMessage = error.message || 'Network error - please check your connection';
      toast.error(errorMessage);
      return Promise.reject({ message: errorMessage, status: 0 });
    }

    const { status, data, config } = error.response;
    console.log(status, data, config  , 'status, data, config')
    const errMsg =error.response.data.message || 'An error occurred'; 

    console.warn(`[API ERROR] ${status} ${config?.url}`, data);

    switch (status) {
      case 400:
        toast.error(errMsg);
        break;
      case 401:
        toast.error('Session expired. Redirecting...');
        localStorage.removeItem('authToken');
        localStorage.removeItem('authData');
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
        break;
      case 403:
        toast.error('⛔ Access denied. You do not have permission to perform this action.');
        // Optional: Redirect to a no-permission page or dashboard
        // setTimeout(() => {
        //   window.location.href = '/no-permission';
        // }, 1500);
        break;
      case 404:
        // Don't show error for expected 404s (e.g., checking if conveyancing lead exists)
        if (!config?.url?.includes('getConveyancingLead') &&
            !config?.url?.includes('getEditDataPurchaseConveyancing') &&
            !config?.url?.includes('edit-conveyancing-data') &&
            !config?.url?.includes('conveyancing-view')) {
          toast.error('🔍 Not found.');
        }
        break;
      case 409:
        // Don't show toast for duplicate customer warning - let component handle it
        if (!data?.isDuplicate) {
          toast.error(errMsg);
        }
        // Return the error response data for duplicate customer handling
        return Promise.reject({
          status,
          message: errMsg,
          data,
          isDuplicate: data?.isDuplicate,
          duplicateCustomer: data?.duplicateCustomer
        });
      case 422:
         toast.error(errMsg);
        return Promise.reject({
          status,
          errors: data.errors || {},
          message: errMsg,
        });
          case 407:
         toast.error(errMsg);
        return Promise.reject({
          status,
          errors: data.errors || {},
          message: errMsg,
        });
        
        
      case 500:
        toast.error('💥 Server error.');
        break;
      default:
        toast.error(errMsg);
    }

    return Promise.reject({
      status,
      message: errMsg,
      data,
    });
  }
);


export default axiosInstance;
